import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { theme } from '@styles';

export const rowPaddingYinPx = 8;

export const dataTableImageHeightInPx = 64;

export const dataTableColumnWidths = {
  locations: [50, 128, 216, 240, 427, 70],
};

export const SuperscriptionWrap = styled(Box)(() => ({
  marginBottom: theme.spacing(2.5),
}));

export const getDataTableSx = (isClickable, withBorders) => ({
  '& .MuiDataGrid-row:hover': {
    cursor: isClickable ? 'pointer' : 'auto',
  },
  ...(!withBorders && {
    border: 'none',
    '& .MuiDataGrid-cell': {
      borderRight: 'none',
    },
    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: `1px solid ${theme.color.gray[200]}`,
    },
  }),
});
